/**
 * Table and Card Interaction Handlers
 *
 * Thin dispatcher that wires table and card click events to per-action handlers.
 */

import { setupTableRowHandler } from './table/tableRowDispatcher';
import { setupCardContainerHandler } from './table/mobileCardActions';
import { setupOutcomeModalHandlers } from './table/lifecycleHandlers';
import { setupExportModalHandlers } from './table/exportHandlers';
import { handleImageLoadError } from './table/imageErrors';
import type { TableHandlerDeps, TableHandlerElements } from './table/types';

export type { TableHandlerDeps, TableHandlerElements } from './table/types';

export function setupTableHandlers(deps: TableHandlerDeps): void {
  const { els } = deps;

  setupTableRowHandler(deps);
  setupCardContainerHandler(deps);
  setupOutcomeModalHandlers(deps);
  setupExportModalHandlers(deps);

  if (els.rows) {
    els.rows.addEventListener('error', handleImageLoadError, true);
  }
  if (els.imagesModalContent) {
    els.imagesModalContent.addEventListener('error', handleImageLoadError, true);
  }
  if (els.lotDetailsModalContent) {
    els.lotDetailsModalContent.addEventListener('error', handleImageLoadError, true);
  }
}
